import React, { useContext, useMemo, useState } from 'react';

import HasPendingRequestWarning from '../../budget_approval_requests/HasPendingRequestWarning';
import { PacksDispatchContext } from '../ApiProvider';

import EditIcon from 'Assets/icons/edit.svg';
import MinusIcon from 'Assets/icons/minus.svg';
import PlusIcon from 'Assets/icons/plus.svg';

export default function Pack({ pack, i, requestsUrl }) {
    const [collapsed, setCollapsed] = useState(true);

    const apiCall = useContext(PacksDispatchContext);
    const costPerPack = useMemo(() => pack.pack_children.reduce((total, item) => total + item.pivot.amount * item.price, 0), [pack]);

    return (
        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200">
            <div className="tw-p-2.5 tw-space-y-4">
                <div className="tw-flex tw-gap-2 tw-items-center">
                    <div className="tw-basis-full tw-shrink tw-grow">
                        <div>{pack.name}</div>
                    </div>
                    <div className="tw-basis-full tw-shrink tw-grow">
                        <div>{costPerPack}</div>
                    </div>
                    <div className="tw-basis-16 tw-shrink-0 tw-flex tw-items-center tw-justify-end tw-space-x-3">
                        {!!pack.can_be_edited && (
                            <button
                                onClick={(e) =>
                                    apiCall('form', {
                                        type: pack.pack_contractor ? 'createContractorPack' : 'createSimplePack',
                                        id: pack.id,
                                    })
                                }
                            >
                                <EditIcon className="tw-w-4 tw-h-4" />
                            </button>
                        )}
                        <button className="table__icon-btn tw-text-white" onClick={() => setCollapsed((state) => !state)}>
                            {collapsed ? <PlusIcon className="tw-w-3.5 tw-h-3.5" /> : <MinusIcon className="tw-w-3.5 tw-h-3.5" />}
                        </button>
                    </div>
                    {!pack.can_be_edited && <HasPendingRequestWarning />}
                </div>

                {!collapsed && (
                    <div className="tw-space-y-3">
                        <AssignedItems packId={pack.id} pack_children={pack.pack_children} isContractor={pack.pack_contractor} />
                        {!!window.canSave && !!pack.can_be_edited && (
                            <div className="tw-rounded-lg tw-border-2 tw-border-dashed tw-border-gray-200 tw-bg-gray-50 tw-text-center tw-p-4">
                                {$t('Drag and Drop Pack Item')}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

const AssignedItems = ({ pack_children, packId, canBeEdited, isContractor }) => {
    return (
        <div className="tw-flex tw-flex-col tw-max-h-52 tw-space-y-2 tw-overflow-auto">
            <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white tw-sticky tw-top-0 tw-z-10">
                <div className="tw-p-2.5 tw-flex tw-gap-2 tw-items-center tw-text-sm tw-font-semibold tw-text-charcoal">
                    <div className="tw-basis-full tw-shrink tw-grow">
                        <div>{$t('Description')}</div>
                    </div>
                    <div className="tw-basis-full tw-shrink tw-grow">
                        <div>{isContractor ? $t('Rate Per Hour') : $t('Unit Price')}</div>
                    </div>
                    <div className="tw-basis-full tw-shrink tw-grow">
                        <div>{$t('Qty Per Pack')}</div>
                    </div>
                    <div className="tw-basis-full tw-shrink tw-grow">
                        <div>{$t('Total Per Pack')}</div>
                    </div>
                    <div className="tw-basis-6 tw-shrink-0"></div>
                </div>
            </div>
            {(!!pack_children?.length &&
                pack_children.map((packChild, i) => <AssignedItem key={i} packId={packId} packChild={packChild} canBeEdited={canBeEdited} />)) || <></>}
        </div>
    );
};

const AssignedItem = ({ packChild, packId, canBeEdited }) => {
    const apiCall = useContext(PacksDispatchContext);
    return (
        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white">
            <div className="tw-p-2.5 tw-flex tw-gap-2">
                <div className="tw-basis-full tw-shrink tw-grow">
                    <div>{packChild.name}</div>
                </div>
                <div className="tw-basis-full tw-shrink tw-grow">
                    <div>{packChild.price}</div>
                </div>
                <div className="tw-basis-full tw-shrink tw-grow">
                    <div>{packChild.pivot.amount}</div>
                </div>
                <div className="tw-basis-full tw-shrink tw-grow">
                    <div>{packChild.price * packChild.pivot.amount}</div>
                </div>
                <div className="tw-basis-6 tw-shrink-0 tw-flex tw-items-center tw-justify-end tw-space-x-3">
                    {!!window.canSave && packChild.can_be_edited && (
                        <button
                            onClick={() => {
                                apiCall('itemToPack', { itemId: packChild.id, packId: packId });
                            }}
                        >
                            <EditIcon className="tw-w-4 tw-h-4" />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
